import React, { useEffect } from "react";
import { connect } from 'react-redux';
import Quagga from "quagga";
import './barcode-scanner.scss';

let timeoutFuncId = null;

const Scanner = props => {
    const { onDetected, onFailed } = props;
    const timeOut = 30000;
    useEffect(() => {
        const onBarcodeDetect = result => {
            clearTimeout(timeoutFuncId);
            Quagga.stop();
            onDetected(result.codeResult.code);
        }

        Quagga.init({
            numOfWorkers: Math.max(navigator.hardwareConcurrency, 1),
            inputStream : {
                name : "Live",
                type : "LiveStream",
                target: document.querySelector('#barcode-scanner'),
                constraints: {
                    aspectRatio: { "min": 1, "max": 5 },
                    facingMode: "environment"  //"environment" for back camera, "user" front camera
                }
            },
            /* debug: {
                drawBoundingBox: false,
                showFrequency: false,
                drawScanline: false,
                showPattern: false
            }, */
            decoder : {
                readers: ["ean_reader","code_128_reader"],
                multiple: false
            }
        }, function(err) {
            if (err) {
                console.log(err);
                onFailed({status:1,type:'permissionDenied'});
                return;
            }
            console.log("Initialization finished. Ready to start");
            Quagga.start();
            timeoutFuncId = setTimeout(()=>{
                console.log("Scanning Failed");
                Quagga.stop();
                onFailed();
            },timeOut)
        })
        Quagga.onDetected(onBarcodeDetect);

        const onProcessed = result => {
            var drawingCtx = Quagga.canvas.ctx.overlay,
                drawingCanvas = Quagga.canvas.dom.overlay;
    
            if (result) {
                if (result.boxes) {
                drawingCtx.clearRect(
                    0,
                    0,
                    Number(drawingCanvas.getAttribute("width")),
                    Number(drawingCanvas.getAttribute("height"))
                );
                result.boxes
                    .filter(function(box) {
                    return box !== result.box;
                    })
                    .forEach(function(box) {
                    Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                        color: "green",
                        lineWidth: 2
                    });
                    });
                }
    
                if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
                    color: "#00F",
                    lineWidth: 2
                });
                }
    
                if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(
                    result.line,
                    { x: "x", y: "y" },
                    drawingCtx,
                    { color: "red", lineWidth: 3 }
                );
                }
            }
        }
        //detecting boxes on stream
        Quagga.onProcessed(onProcessed);

        return () => {
            clearTimeout(timeoutFuncId);
            Quagga.stop();
            Quagga.offProcessed(onProcessed);
            Quagga.offDetected(onBarcodeDetect);
        }
    }, []);

    return (
        <div id="barcode-scanner" className={'barcode-scan-container'}></div>
    );
};

const mapStateToProps = ({ barcodeScanner }, props) => ({
    ...props,
    ...barcodeScanner
});

export default connect(mapStateToProps)(Scanner);